import React from "react";
import { Link } from "react-router-dom";
import Button from "./Button";

import './CtaSection.css';

const CtaSection = ({ navigateToApp }) => {
  return (
    <section className="cta-section px-5 py-32 text-center">
      <div className="mx-auto my-0 max-w-[800px]">
        <h2 className="mb-6 text-5xl font-bold text-white">
          Ready to invest simply?
        </h2>
        <p className="mb-10 text-xl leading-relaxed text-white text-opacity-90">
          One token. Full exposure. Complete control. No apps. No banks. No
          guesswork.
        </p>
        <div className="flex gap-4 justify-center max-sm:flex-col max-sm:items-center">
          <Button variant="primary" onClick={navigateToApp}>
            See App
          </Button>
          <Link to="/docs">
            <Button variant="secondary">Read Docs</Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;